<template>
  <Main>
    <OfficeForm
      :form="form"
      @submit="submit"
      @cancel="previousPage"
      :text-button="'CRIAR'"
      v-if="form"
    />
    <ModalCancelOffice
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
    <ModalSaveOffice
      @close="closeModalSuccess"
      v-model="modalSuccess"
      title="ESCRITÓRIO ADICIONADO COM SUCESSO!"
      text="Você deseja adicionar um novo escritório?"
    />
  </Main>
</template>
<script>
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalCancelOffice from "../../insurance_company/components/ModalCancelInsurance";
import ModalSaveOffice from "../../insurance_company/components/ModalCancelInsurance";
import OfficeForm from "../components/OfficeForm";
import { normalizeCnpj } from "@/utils/documents.js";
import _ from "lodash";
import FormMixin from "@/mixins/FormMixin";
const MOCK_FORM = {
  cnpj: "",
  razao_social: "",
  nome_fantasia: "",
  ativo: true,
  restrito: true
};
export default {
  beforeRouteLeave(to, from, next) {
    if (this.cancel || this.formIsPristineCommon(this.form, this.cloneForm))
      next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  data: () => ({
    form: {},
    modalCancel: false,
    cancel: false,
    nextRoute: null,
    modalSuccess: false,
    cloneForm: {}
  }),
  mixins: [LoadingRequest, FormMixin],
  components: {
    ModalCancelOffice,
    ModalSaveOffice,
    OfficeForm
  },
  created() {
    this.form = _.cloneDeep(MOCK_FORM);
    this.cloneForm = _.cloneDeep(this.form);
  },
  methods: {
    ...mapActions("office", ["requestCreateOffice"]),
    submit(form) {
      // Normaliza o CNPJ para garantir que letras e números sejam preservados no payload.
      const payload = {
        ...form,
        cnpj: normalizeCnpj(form.cnpj)
      };
      this.withLoading(
        this.requestCreateOffice(payload).then(() => {
          this.modalSuccess = true;
          this.form = null;
        })
      );
    },
    previousPage() {
      this.$router.push({ name: "office" });
    },
    closeModalSuccess(value) {
      this.modalSuccess = false;
      if (value) {
        this.form = _.cloneDeep(MOCK_FORM);
      } else {
        this.cancel = true;
        this.$router.push({ name: "office" });
      }
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({ name: this.nextRoute.name });
      }
    }
  }
};
</script>
